// extracted by mini-css-extract-plugin
export default {"wrapper":"PnX1JsZD7EJmIZOiIjrg","button":"OgXaBkJDSojQKKOCZUbR"};